// @flow
import * as React from 'react';
import { Button } from 'grommet';
import { withRouter } from 'speed-js-react';
import { normalizeToLocation, resolveToLocation } from 'react-router-dom/modules/utils/locationUtils';

type Props = {
    to: string,
    onClick?: (e: SyntheticMouseEvent<HTMLButtonElement>) => void,
    method: 'push' | 'replace',
    history: Object,
    location: Object,
}


@withRouter
class RoutedButton extends React.Component<Props> {
    static defaultProps = {
        method: 'push',
        onClick: undefined,
        history: {},
    };

    onClick = (e: SyntheticMouseEvent<HTMLButtonElement>) => {
        const {
            method, onClick, to, history,
        } = this.props;

        if (e) {
            const modifierKey = e.ctrlKey || e.metaKey;

            // if the user right-clicked in the button we should let it go
            if (modifierKey) {
                return;
            }
        }
        if (history) {
            e.preventDefault();
            history[method](to);
        }
        if (onClick) {
            onClick(e);
        }
    };

    render() {
        const {
            to, history, location, ...rest
        } = this.props;

        const normalizedLocation = normalizeToLocation(
            resolveToLocation(to, location),
            location,
        );

        return (
            <Button
                {...rest}
                href={history.createHref(normalizedLocation)}
                onClick={this.onClick}
            />
        );
    }
}

export default RoutedButton;
